import React, { Fragment } from 'react';

import '../../../../BotReport/index.css';

import chaticon from '../../../../../../../assets/images/chat.svg';
import ContainerReport from '../../../../ContainerReport';

const OrgBotTotalConsumption = ({ totalConsumption }) => {
  const renderContainerContent = () => {
    return (
      <Fragment>
        <div className="container-dados-relatorio">
          <p className="result-relatorio-yellow">{totalConsumption}</p>
          <span className="tipo-relatorio">Nesta org.</span>
        </div>
      </Fragment>
    );
  };

  return (
    <ContainerReport
      type="absolute"
      icon={chaticon}
      title="Total de Sessões"
      containerContent={renderContainerContent()}
    />
  );
};

export default OrgBotTotalConsumption;
